import { render } from "./DisplayMyVotes.vue?vue&type=template&id=128466f0"
import script from "./DisplayMyVotes.vue?vue&type=script&lang=js"
export * from "./DisplayMyVotes.vue?vue&type=script&lang=js"

import exportComponent from "/Users/johnahnz0rs/00 - JAHN PROJECTS/movie-night/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__